// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer {
  display: flex;
  flex:1 1;
}

.leftContainer {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: center;
  padding:0 10rem;
}

.rightContainer {
  width: 50%;
}

.rightContainerContent {
  position: relative;
  flex: 1 1;
  display: flex;
}

.rightContainerOverlayContainer {
  position: absolute;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex:1 1;
  z-index: 1;
  bottom: 10px;
  left: 0;
  right: 0;
  align-items: center;
  align-self: center;
  color: white;
}

@media screen and (max-width: 1200px) {
  .leftContainer {
    padding:0 5rem;
  }
}

@media screen and (max-width: 900px) {
  .leftContainer {
    padding:5rem 5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/auth/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAM;EACN,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".mainContainer {\n  display: flex;\n  flex:1;\n}\n\n.leftContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  padding:0 10rem;\n}\n\n.rightContainer {\n  width: 50%;\n}\n\n.rightContainerContent {\n  position: relative;\n  flex: 1;\n  display: flex;\n}\n\n.rightContainerOverlayContainer {\n  position: absolute;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  flex:1;\n  z-index: 1;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n  align-items: center;\n  align-self: center;\n  color: white;\n}\n\n@media screen and (max-width: 1200px) {\n  .leftContainer {\n    padding:0 5rem;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .leftContainer {\n    padding:5rem 5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
